
import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import MuiTableWrapper from "app/pages/Docgen/components/common/mui-table-wrapper/MuiTableWrapper";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Div from "@jumbo/shared/Div/Div";
import DifferenceOutlinedIcon from "@mui/icons-material/DifferenceOutlined";
import FormSearchFilter from "app/pages/Docgen/components/common/form-search-filter/FormSearchFilter";
import { get } from "../../../common/network";
import {DateFormatter, Date_format, formatDate} from "../../../constants/date_format";

const HistoryTab = ({ id }) => {
  //#region for states
  const [selectedRows, setSelectedRows] = useState([]); // Array of the selected rows
  const [dataModal, setDataModal] = useState(false);
  const [historyId, setHistoryId] = useState("");
  const [getUpdatedBy, setUpdatedBy] = useState("");
  const [getUpdatedAt, setUpdatedAt] = useState("");


  const [data, setData] = useState([]);
  const [historyData,setHistoryData] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [historyLoading,setHistoryLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [dateValue, setDateValue] = useState("");
  const [rowsSelection,setRowsSelection] = useState([]);

  //#endregion

  //#region for functions
  const handleDataModalClose = () => {
    setDataModal(false);
  };
  //#endregion

  //#region for fake data
  const columns = [
    {
      field: "type",
      header: "Change Type",
    },
    {
      field: "updated_by",
      header: "Updated By",
      render: (value, row) => {
        const first_name = row?.user?.first_name;
        const last_name = row?.user?.last_name;
        setUpdatedBy(`${first_name} ${last_name}`);
        return `${first_name} ${last_name}`;
      },
    },
    {
      field: "updated_at",
      header: "Update Date",
      render: (value) => {
        const date = new Date(value); // Convert the ISO date string to a Date object
        return DateFormatter(date);
      },
    },
    {
      field: "view_change",
      header: "View Data Change",
      render: (value, row) => {
        return (
          <Button
            variant="text"
            className="listing-btn"
            sx={{
              textDecoration: "none !important",
            }}
            onClick={() => {
              const first_name = row?.user?.first_name;
              const last_name = row?.user?.last_name;
              setUpdatedBy(`${first_name} ${last_name}`);
              setHistoryId(row.id);
              setUpdatedAt(row.updated_at);
              setDataModal(true);
            }}
          >
            <DifferenceOutlinedIcon
              sx={{
                fontSize: "20px",
                color: "inherit",
                mr: "4px",
              }}
            />{" "}
            View
          </Button>
        );
      },
    },
  ];



  const handleSearch = (value) => {
    const columnName = value?.value || ""; // Name of the column
    const searchValue = value?.searchedText || ""; // Value entered in the input field

    setSearchValue(searchValue);

    setFilterText(columnName);

    if (columnName === "updated_at") {
      setDateValue(value);
    }
  };

  const fetchData = async () => {
    setIsFetching(true);
    try {
      const response = await get(
        `docgen/matterhistory/${id}`          //`docgen/matterhistory/${id}?page=${page}&pageSize=${rowsPerPage}${filterText}&${sortedColumn}&${sort}`
      );
      const rows = response?.data ?? [];

      // Modify each row to include the old and new values
      const rowsWithChanges = rows.map((row) => ({
        ...row,
        old_value: JSON.parse(row.old_value),
        new_value: JSON.parse(row.new_value),
      }));

      setData(rowsWithChanges);
    } catch (error) {
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(()=> {
    fetchData();
  },[])
  //#endregion

  //#region for history tab
  const historyColumns = [
    {
      field: "field_name",
      header: "Docket Field Name",
    },
    {
      field: "old_val",
      header: "Old Value",
      render: (value) => {
        // Check if the value matches either ISO 8601 or date-only format
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value)) {
          const date = new Date(value);
          if (!isNaN(date)) {
            return DateFormatter(date); // Format the ISO 8601 date
          }
        } else if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          // Handle date-only format
          return formatDate(value, true);
        }

        return value; // Return the original value if it doesn't match either format
      },
    },
    {
      field: "new_val",
      header: "New Value",
      render: (value) => {
        // Check if the value matches either ISO 8601 or date-only format
        if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value)) {
          const date = new Date(value);
          if (!isNaN(date)) {
            return DateFormatter(date); // Format the ISO 8601 date
          }
        } else if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
          // Handle date-only format
          return formatDate(value, true);
        }

        return value; // Return the original value if it doesn't match either format
      },
    },
    {
      field: "updated_at",
      header: "Date",
      render: (value) => {
        const date = new Date(value); // Convert the ISO date string to a Date object
        return DateFormatter(date);
      },
    },
    {
      field: "updated_by",
      header: "Updated by",
    },
  ];

  const fetchHistoryData = async () => {
    setHistoryLoading(true);
    try {
      const response = historyId && await get(`docgen/matterhistorydetails/${historyId}`);
      const rows = response?.data ?? [];

      // Modify each row to include the old and new values
      const rowsWithChanges = rows.map((row) => {
        const formattedRow = {};

        for (const [key, value] of Object.entries(row)) {
          formattedRow.field_name = key;

          // Check if key ends with "__deleted"
          if (key.endsWith("__deleted")) {
            // Remove the "__deleted" part from the key
            formattedRow.field_name = key.replace(/__deleted$/, "");

            // Show only the value, replacing value.__new if available
            formattedRow.old_val = value;
            formattedRow.new_val = undefined; // Set to undefined to exclude it
          } else if (key.endsWith("__added")) {
            // Remove the "__deleted" part from the key
            formattedRow.field_name = key.replace(/__added$/, "");

            // Show only the value, replacing value.__new if available
            formattedRow.old_val = undefined;
            formattedRow.new_val = value; // Set to undefined to exclude it
          } else {
            // For other keys, use value.__old if available, else use the value
            formattedRow.old_val = value.__old;
            formattedRow.new_val = value.__new;
          }

          formattedRow.updated_by = getUpdatedBy;
          formattedRow.updated_at = getUpdatedAt;
        }

        return formattedRow;
      });
      setHistoryData(rowsWithChanges);
    } catch (error) {
    } finally {
      setHistoryLoading(false);
    }
  };

  useEffect(()=>{
    fetchHistoryData();
  },[historyId])
  //#endregion

  return (
    <div className="page-content-wrapper">
      <Box className="w-100">
        <header className="section-heading">
          <div className="left-area">
            <FormSearchFilter
              options={[
                { value: "all", label: "All" },
                { value: "type", label: "Change Type" },
                { value: "updated_by", label: "Updated By" },
                { value: "updated_at", label: "Update Date" },
              ]}
              defaultOption = { {value: "", label: "Select an option"} }
              dateFiltersOptionsValueArray={["updated_at"]}
              onSearch={(values) => handleSearch(values)}
            />
          </div>
        </header>
        {/* <div style={{ height: '90vh', overflow: 'auto' }}> */}
          <MuiTableWrapper
            columns={columns}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
            hasCheckboxesColumn={false}

            searchValue={searchValue}
            filterColumn={filterText}
            data={data}
            isFetching={isFetching}
            dateValue={dateValue}
            rowsSelection={rowsSelection}
            setRowsSelection={setRowsSelection}
          />
        {/* </div> */}
      </Box>
      <Modal
        open={dataModal}
        onClose={handleDataModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Div
          sx={{
            height: "60vh !important",
            width: "100%",
            maxWidth: "1000px",
          }}
          className="customize-modal"
        >
          <div className="modal-head">
            <h2>Changed Data</h2>
            <IconButton
              className="close-modal-btn p-0"
              onClick={handleDataModalClose}
            >
              <HighlightOffIcon />
            </IconButton>
          </div>
          <div className="modal-body-content">
            {

              <>
                <div className="table-responsive" style={{ height: '90vh', overflow: 'auto' }}>
                  <MuiTableWrapper
                    columns={historyColumns}
                    data={historyData}
                    selectedRows={[]}
                    setSelectedRows={() => {}}
                    hasCheckboxesColumn={false}
                    colgroup={[
                      { width: "20%" },
                      { width: "25%" },
                      { width: "25%" },
                      { width: "15%" },
                      { width: "15%" },
                    ]}

                    searchValue={""}
                    filterColumn={"all"}
                    isFetching={historyLoading}
                    rowsSelection={rowsSelection}
                    setRowsSelection={setRowsSelection}
                  
                  />
                </div>
              </>
            }
          </div>
        </Div>
      </Modal>
    </div>
  );
};

export default HistoryTab;